import cn from 'classnames';
import Img from 'components/common/Img';
import React from 'react';
import { loadingWhite } from 'redhotpie-shared-lib/themes/ImagesSVG';
import Div from '../Div';
import './style.scss';

const colors = Object.freeze({
  primary: 'member-button--primary',
  outlinePrimary: 'member-button--outline-primary',
  primaryBlue: 'member-button--primary-blue',
  outlinePrimaryBlue: 'member-button--outline-primary-blue',
  outline: 'member-button--outline',
  secondary: 'member-button--secondary',
  black: 'member-button--black',
  white: 'member-button--white',
  coins: 'member-button--coins',
  link: 'member-button--link',
  gray: 'member-button--gray',
  linkBlue: 'member-button--link-blue',
  outlineGray: 'member-button--outline color-gray',
  outlineBlack: 'member-button--outline color-black',
  outlineWhite: 'member-button--outline color-white',
  greenGreen: 'member-button--green',
  pending: 'member-button--pending',
  green: 'member-button--green-only',
  text: 'member-button--text',
});

const rounds = {
  sm: 'member-button--round-sm',
  md: 'member-button--round-md',
  lg: 'member-button--round-lg',
  xl: 'member-button--round-xl',
};

type COLOR_TYPE =
  | 'primary'
  | 'outlinePrimary'
  | 'primaryBlue'
  | 'outlinePrimaryBlue'
  | 'outline'
  | 'secondary'
  | 'black'
  | 'white'
  | 'coins'
  | 'link'
  | 'linkBlue'
  | 'outlineGray'
  | 'outlineBlack'
  | 'outlineWhite'
  | 'greenGreen'
  | 'pending'
  | 'green'
  | 'text'
  | 'gray';

interface MemberButtonProps {
  type?: string | 'md';
  onClick?: (e: any) => void;
  upperCase?: boolean;
  isTextCapitalize?: boolean;
  text?: string | number | boolean | React.ReactNode;
  className?: string;
  isCarousel?: boolean;
  isMobile?: boolean;
  iconSrc?: string;
  iconClassName?: string;
  isProspectsReacted?: boolean;
  iconRightSrc?: string;
  isLoading?: boolean;
  registerRef?: any;
  subText?: string;
  children?: React.ReactNode;
  isError?: boolean;
  iconLoading?: string;
  isLarge?: boolean;
  isSmall?: boolean;
  isDesktopButton?: boolean;
  id?: string;
  round?: string;
  color?: COLOR_TYPE | string;
  disabled?: boolean;
  [key: string]: any;
}

function MemberButton(props: MemberButtonProps) {
  const {
    type,
    onClick,
    upperCase,
    isTextCapitalize,
    text,
    className,
    isCarousel,
    isMobile,
    isProspectsReacted,
    color,
    iconRightSrc,
    isLoading,
    iconLoading,
    subText,
    registerRef,
    isError,
    isLarge,
    isSmall,
    isDesktopButton,
    id,
    round,
    disabled,
    ...otherProps
  } = props;
  // const isDesktopButton = !(isMobile || phoneDetect());
  let { iconSrc, iconClassName } = props;
  if (isLoading) {
    iconSrc = iconLoading || loadingWhite;
    iconClassName = 'spinner-loading rotating';
  }
  const customClass = cn('member-button', colors[(color as keyof typeof colors) || ''], rounds[round as keyof typeof rounds], {
    [className || '']: className,
    [`button-${type}`]: type,
    'upper-case': upperCase,
    'txt-trans-capitalize': isTextCapitalize,
    'disable-button': isError,
    'button-disabled': disabled,
    'button-send-msg-mobile': isLarge,
    'button-small': isSmall,
    'desktop-button': isDesktopButton,
  });

  const customClassImage = cn('member-icon', {
    'img-30px': isCarousel && !isMobile,
    [iconClassName || '']: iconClassName,
    'icon-loading': isLoading,
  });
  return (
    <Div
      id={id}
      onClick={isLoading || isError || disabled ? undefined : onClick}
      className={customClass}
      {...otherProps}
      refDiv={(elm: any) => (typeof registerRef === 'function' ? registerRef(elm) : null)}
      data-cy={id}>
      <>
        {iconSrc && <Img src={iconSrc} className={customClassImage} alt="icon-src" />}{' '}
        {!isLoading && (isProspectsReacted ? (text || '').toString().toUpperCase() : text && text)}
        {subText && <span>{subText}</span>}
        {!isLoading && iconRightSrc && <Img src={iconRightSrc} className={customClassImage} alt="icon-right" />}
        {props.children}
      </>
    </Div>
  );
}

export default MemberButton;
